import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";
import { GridActionsCellItem } from "@mui/x-data-grid";
import Tooltip from '@mui/material/Tooltip';
import { useState } from 'react';
import { policies as permessi } from "../../const/policies"
import { useNavigate } from 'react-router-dom';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import { faBan, faPen, faTrash, faRotateRight, faDoorOpen, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography, Menu, Box, IconButton, Divider, MenuItem, MenuList, ListItemIcon, ListItemText } from "@mui/material";
import useMobileDetection from '../../Hooks/useMobileDetection';
import { handleDialogToEditZone, handleDialogToEnableDisableZone } from './operations/handlerDialogToEditZone';
import { dialogPageTypes } from '../../const/dialogPageTypes';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { setScrollY } from "../../redux/reducers/scroll-reducer";


const ButtonBoxZone = ({ row: rowInfo }) => {
  const { t } = useTranslation();
  const state = useSelector((state) => state.userDate);
  const { policies, responsabileEdificio } = state;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useMobileDetection(600);
  const viewState = useSelector((state) => state.viewState);
  const idZona = rowInfo.id;
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const menuOpen = Boolean(menuAnchorEl);

  const handleMenuClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    dispatch(setScrollY(document.querySelector("main.MuiBox-root").scrollTop));
  };
  const actionButtonStyle = {
    border: "1px solid #dcdcdc",
    borderRadius: "4px",
    padding: "4px 8px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: "#eae5e591",
    cursor: "pointer",
    minWidth: "78px",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
      borderColor: "#3e6bb4",
    },
  };
  return (
    <>
      {!isMobile && !viewState ? (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
            <Tooltip title={t("actions")}>
              <IconButton
                onClick={handleMenuClick}
                size="small"
                sx={{
                  mr: 2,
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                }}
                aria-controls={menuOpen ? 'actions-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={menuOpen ? 'true' : undefined}
              >
                <FontAwesomeIcon icon={faEllipsisV} size="lg" />
              </IconButton>
            </Tooltip>
          </Box>
          <Menu
            anchorEl={menuAnchorEl}
            id="actions-menu"
            open={menuOpen}
            onClose={handleMenuClose}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            slotProps={{
              paper: {
                elevation: 2,
                sx: {
                  mt: 1,
                  borderRadius: "10px",
                  minWidth: 180,
                },
              },
            }}
          >
            {/* 🔹 MODIFICA */}
            {policies.indexOf(permessi.zoneInserimentoModifica) !== -1 && (
              <MenuItem
                onClick={(event) =>
                  handleDialogToEditZone(
                    { type: "edit", row: rowInfo },
                    dispatch,
                    event
                  )
                }
              >
                <ListItemIcon>
                  <FontAwesomeIcon icon={faPen} />
                </ListItemIcon>
                <ListItemText>{t("edit")}</ListItemText>
              </MenuItem>
            )}

            {/* 🔹 ELIMINA */}
            {policies.indexOf(permessi.utentiVisualizzazione) !== -1 && (
              <MenuItem
                onClick={(event) =>
                  handleDialogToEditZone(
                    { type: "delete", row: rowInfo },
                    dispatch,
                    event
                  )
                }
              >
                <ListItemIcon>
                  {rowInfo.dataDel ? (
                    <FontAwesomeIcon icon={faBan} />
                  ) : (
                    <FontAwesomeIcon icon={faTrash} />
                  )}
                </ListItemIcon>
                <ListItemText>
                  {!rowInfo.dataDel ? t("delete") : t("enable")}
                </ListItemText>
              </MenuItem>
            )}

            <Divider />

            {/* 🔹 DISABILITA */}
            {(policies.indexOf(permessi.edificiAbilitaDisabilita) !== -1 ||
              responsabileEdificio.length > 0) && (
                <MenuItem
                  onClick={(event) =>
                    handleDialogToEnableDisableZone(
                      {
                        dialogPageType: dialogPageTypes.zone,
                        dialogType: "disableRangeData",
                        rowInfo,
                      },
                      dispatch,
                      event
                    )
                  }
                >
                  <ListItemIcon>
                    <FontAwesomeIcon icon={faBan} />
                  </ListItemIcon>
                  <ListItemText>{t("disable_v3")}</ListItemText>
                </MenuItem>
              )}

            {/* 🔹 ABILITA */}
            {(policies.indexOf(permessi.edificiAbilitaDisabilita) !== -1 ||
              responsabileEdificio.length > 0) && (
                <MenuItem
                  onClick={(event) =>
                    handleDialogToEnableDisableZone(
                      {
                        dialogPageType: dialogPageTypes.zone,
                        dialogType: "ripristinaAll",
                        rowInfo,
                      },
                      dispatch,
                      event
                    )
                  }
                >
                  <ListItemIcon>
                    <FontAwesomeIcon icon={faRotateRight} />
                  </ListItemIcon>
                  <ListItemText>{t("restore_v2")}</ListItemText>
                </MenuItem>
              )}

            <Divider />

            {/* 🔹 VAI ALLE STANZE */}
            {policies.indexOf(permessi.stanzeVisualizzazione) !== -1 && (
              <MenuItem onClick={() => navigate("" + idZona)}>
                <ListItemIcon>
                  <FontAwesomeIcon icon={faArrowRight} />
                </ListItemIcon>
                <ListItemText>{t("rooms")}</ListItemText>
              </MenuItem>
            )}
          </Menu>
        </>
      ) : (
        <>
          {(policies.indexOf(permessi.edificiAbilitaDisabilita) !== -1 ||
            responsabileEdificio.length > 0) && (
              <GridActionsCellItem
                sx={{ '& .MuiTouchRipple-root': { display: 'none' } }}
                className={isMobile || viewState ? "button-ButtonBox-Mobile forceNoPaddingLeft" : ""}
                icon={
                  <Tooltip title={t("disable_v3")}>
                    <div style={actionButtonStyle}>
                      <>
                        <FontAwesomeIcon icon={faBan} size="xs" style={{ color: "#636161", marginRight: "3px" }} />
                        <Typography sx={{ fontSize: 10, color: "#636161" }}>{t("disable_v3")}</Typography>
                      </>
                    </div>
                  </Tooltip>
                }
                label={t("disable_v3")}
                onClick={(event) =>
                  handleDialogToEnableDisableZone({ dialogPageType: dialogPageTypes.zone, dialogType: "disableRangeData", rowInfo }, dispatch, event)
                }
              />
            )}

          {(policies.indexOf(permessi.edificiAbilitaDisabilita) !== -1 ||
            responsabileEdificio.length > 0) && (
              <GridActionsCellItem
                sx={{ '& .MuiTouchRipple-root': { display: 'none' } }}
                className={isMobile ? "button-ButtonBox-Mobile forceNoPaddingLeft" : ""}
                icon={
                  <Tooltip title={t("restore_v2")}>
                    <div style={actionButtonStyle}>
                      <FontAwesomeIcon icon={faRotateRight} size="xs" style={{ color: "#636161", marginRight: "3px" }} />
                      <Typography sx={{ fontSize: 10, color: "#636161" }}>{t("restore_v2")}</Typography>
                    </div>
                  </Tooltip>
                }
                label={t("restore_v2")}
                onClick={(event) =>
                  handleDialogToEnableDisableZone({ dialogPageType: dialogPageTypes.zone, dialogType: "ripristinaAll", rowInfo }, dispatch, event)
                }
              />
            )}

          {policies.indexOf(permessi.utentiVisualizzazione) != -1 && <GridActionsCellItem
            sx={{ '& .MuiTouchRipple-root': { display: 'none' } }}
            className={isMobile ? "button-ButtonBox-Mobile forceNoPaddingLeft" : ""}
            icon={
              <Tooltip title={!rowInfo.dataDel ? t("delete") : t("enable")}>
                <div style={actionButtonStyle}>
                  {rowInfo.dataDel
                    ? <FontAwesomeIcon icon={faBan} style={{ fontSize: 25 }} className="pathIcon" />
                    : <>
                      <FontAwesomeIcon icon={faTrash} size="xs" style={{ color: "#636161", marginRight: "3px" }} />
                      <Typography sx={{ fontSize: 10, color: "#636161" }}>{t("delete_v3")}</Typography>
                    </>
                  }</div>
              </Tooltip>
            }
            label={t("delete")}
            onClick={(event) => handleDialogToEditZone({ type: "delete", row: rowInfo }, dispatch, event)}
          />}
        </>
      )}
    </>
  );

};

export default ButtonBoxZone;
